// extracted by mini-css-extract-plugin
export default {"tag":"ProfileTextLinkLayout_tag__XvWG2","container":"ProfileTextLinkLayout_container__mWaOm"};